<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top" v-if="status==0">
          <el-button class="new-btn" @click="addOrder">
            <i class="el-icon-plus"></i>
            添加
          </el-button>
          <el-button class="new-btn" @click="sendOrder">
            发样
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="amount"
            width="50"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="price"
            width="60"
            label="价格">
          </el-table-column>
          <el-table-column
            prop="cnas"
            width="90"
            label="CNAS">
            <template slot-scope="scope">{{ scope.row.cnas | cnas_filter}}</template>
          </el-table-column>
          <el-table-column
            prop="measure"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            label="等级">
          </el-table-column>
          <el-table-column
            prop="vendor"
            label="生产厂家">
          </el-table-column>
          <el-table-column
            prop="equip_code"
            width="80"
            label="器具编号">
          </el-table-column>
          <el-table-column
            prop="cert_code"
            label="证书编号">
          </el-table-column>
          <el-table-column
            prop="device_user"
            width="70"
            label="工程师">
          </el-table-column>
          <el-table-column
            prop="lab_name"
            label="委外实验室">
          </el-table-column>
          <el-table-column
            prop="result_str"
            width="65"
            label="状态">
          </el-table-column>
          <el-table-column label="操作" v-if="status==0 || status==1" width=100>
            <template slot-scope="scope">
              <el-button size="mini"
                class="edit-btn"
                @click="handleEdit(scope.row)"
                v-if="scope.row.status==0 || scope.row.status==1"
                >
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
              <el-button size="mini"
                class="delete-btn"
                @click="handleDelete(scope.row, scope.$index)"
                v-if="scope.row.status==0"
                >
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column width="180" label="查看证书" v-if="history_state">
            <template slot-scope="scope">
              <el-button
                class="edit-btn"
                @click="displayItemDetail(scope.row)"
                v-if="user_type == 1 || user_type == 5"
                >
                仪器详情
              </el-button>
              <el-button
                class="edit-btn"
                 @click="goSend(scope.row)"
                 v-if="user_type == 2 && (scope.row.service_type == 0 ||  scope.row.service_type == 1)"
                >
                查看证书
                </el-button>
                <el-button
                class="edit-btn"
                v-else-if="user_type != 2 &&(scope.row.service_type == 0 ||  scope.row.service_type == 1) && (scope.row.status == 5 || scope.row.status  == 8) && payment == 1"
                 @click="download(scope.row)"
                >
                查看证书
                </el-button>
                <el-button
                size="mini" class="delete-btn" @click="handleDlgRevert(scope.row, scope.$index)" 
                v-if="user_type==2 && (scope.row.status==3 || scope.row.status==4) && scope.row.result!=7"
                >撤回证书</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog
      title="仪器详情"
      class="dialog-container"
      :visible.sync="deviceItemDetailShow"
      >
      <el-form class="form-container" :model="device" >
        <el-form-item label="仪器名称" class="input-list">
          <el-input type="text" class="input-txt" v-model="device.dev_name"> </el-input>
        </el-form-item>
        <el-form-item label="仪器型号" class="input-list">
          <el-input type="text" class="input-txt" v-model="device.device_serial"> </el-input>
        </el-form-item>
        <el-form-item label="证书日期" class="input-list">
          <el-input type="text" class="input-txt" v-model="device.cert_effective_date"> </el-input>
        </el-form-item>
        <el-form-item label="到期日期" class="input-list">
          <el-input type="text" class="input-txt" v-model="device.cert_end_date"> </el-input>
        </el-form-item>
        <el-form-item label="备注" class="input-list">
          <el-input type="text" class="input-txt" v-model="device.memo"> </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 点击添加的弹出框 start -->
    <el-dialog
      title="修改仪器"
      class="dialog-container"
      top="0"
      :visible.sync="dialogAdd">
      <div class="form-title">仪器信息</div>
      <el-form class="form-container" :model="device" :rules="deviceRule" ref="device">
        <el-form-item label="仪器名称" class="input-list">
          <p class="input-txt">{{device.device_name}}</p>
        </el-form-item>
        <el-form-item label="仪器范围" class="input-list">
          <p class="input-txt">{{device.measure}}</p>
        </el-form-item>
        <el-form-item label="仪器等级" class="input-list">
          <p class="input-txt">{{device.grade}}</p>
        </el-form-item>
        <el-form-item class="input-list" label="校准方式">
          <el-radio-group class="radio-content" @change="radioChange" v-model="device.measure_type">
            <el-radio class="radio-list" :label="0">校准</el-radio>
            <el-radio class="radio-list" :label="2">检测</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input-list" label="服务类型" >
          <el-radio-group class="radio-content" @change="serveChange" v-model="device.service_type">
            <el-radio class="radio-list" :label="0">自校送检</el-radio>
            <el-radio class="radio-list" :label="1">自校上门</el-radio>
            <el-radio class="radio-list" :label="2">委外送检</el-radio>
            <el-radio class="radio-list" :label="3">委外上门</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 服务类型 委外送检 或者委外上门 选择实验室 -->
        <el-form-item class="input-list" label="实验室"  v-if="options.length > 0" prop="name">
          <el-select class="options-select" v-model="device.service_lab_id" placeholder="请选择实验室">
            <el-option
              v-for="item in options"
              :key="item.lab_id"
              :label="item.name"
              :value="item.lab_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数量" class="input-list input-top" prop="amount">
          <el-input type="text" v-model="device.amount" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="送检日期" class="input-list input-top">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="device.next_date"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="器具编号" class="input-list input-top" prop="aequip_code">
          <el-input type="text" v-model="device.equip_code" placeholder="请输入器具编号"></el-input>
        </el-form-item>
        <el-form-item label="生产厂家" class="input-list input-top" prop="vendor">
          <el-input type="text" v-model="device.vendor" placeholder="请输入生产厂家"></el-input>
        </el-form-item>
        <el-form-item class="input-list input-top" label="备注">
          <el-input
            type="textarea"
            v-model="device.memo"
            placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button class="btn-save" @click="saveDevice('device')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 点击添加 出现的弹窗框 end -->
    <!-- 删除的弹窗框 start -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <!-- 删除的弹出框 end -->
    <!-- 点击发送按钮的 弹出框 start -->
      <div  class="delete-container" v-if="sendShow&&imgSrc.length>0">
        <div class="delete-content">
          <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          <div class="img-container">
            <img class="code-img" :src="imgSrc" alt="">
          </div>
          <!-- <p class="delete-txt">确认委托单要发样?</p>
          <div class="btn-container">
            <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
            <el-button class="btn-list sure-btn" @click="sureDelete">确认</el-button>
          </div> -->
        </div>
      </div>
    <!-- 点击发送按钮的 弹出框 end -->
    <!-- 撤回的弹窗框 start -->
    <div  class="delete-container" v-if="revertShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleRevert"></i>
        <p class="delete-txt">确认要撤回该证书吗?</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleRevert">取消</el-button>
          <el-button class="btn-list sure-btn" @click="sureRevert">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 撤回的弹出框 end -->

  </div>
</template>

<script type='text/ecmascript-6'>
import base from 'common/js/base.js'
import DeleteBox from 'components/DeleteBox.vue'
import { getStore } from 'common/js/mUtils'
import moment from 'moment'
export default {
  data () {
    var amountRule = (rule, value, callback) => {
      let reg =  /^\+?[1-9][0-9]*$/
      if (!reg.test(value)) {
        return callback(this.$message({
          type: 'error',
          message:'仪器数量要为正整数',
          customClass: 'msg-position',
          showClose: true
        }))
      } else {
        return callback()
      }
    }
    return {
      lab_order_id: '',
      empty: '订单没有仪器信息！',
      tableData: [],
      status: '',
      dialogAdd: false,
      device: {},
      deviceRule: {
        amount: [{validator: amountRule, trigger: 'blur'}]
      },
      deleteShow: false,
      deleteRow: {},
      deleteIndex: 0,
      revertShow: false,
      revertRow: {},
      revertIndex: 0,
      sendShow: false,
      imgSrc: '', // 发扬扫描二维码
      options: [],
      type: '',
      user_type: '',
      payment: '',
      history_state: true,   // 暂时取消历史状态检查
      deviceItemDetailShow: false,
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.user_type = getStore('user_type')
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      this.lab_order_id = this.$route.query.lab_order_id
      this.type = this.$route.query.type
      if (this.$route.query.his_state) {
        this.history_state = true
      }
      let fun = ''
      if (this.user_type == 2) { // 工程师历史订单
        fun = 'engineerOrderDetail'
      } else {
        fun = 'orderDetail'
      }
      this.$api[fun]({
        lab_order_id: that.lab_order_id,
        type: that.type
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.status = res.data.status
          that.payment = res.data.payment
        } else {
          that.tableData = []
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    displayItemDetail(device){
      this.device = device
      this.deviceItemDetailShow = true
    },
    addOrder () { // 点击添加button
      this.$router.push({ path: `/orderAddDevice/${this.lab_order_id}`})
    },
    sendOrder () { // 点击发送按钮
      this.initImg()
    },
    initImg () { // 点击发样获取 二维码
      this.$api.scanQrcode({
        scan_type: `o${this.lab_order_id}`
      }).then(res => {
        if (res.data.msg === true) {
          this.imgSrc = res.data.qrcode_url
          this.sendShow = true
        } else {
          this.$message({
            showClose: true,
            message: '缺少委托单号',
            type: 'error',
            customClass: 'msg-position'
          })
        }
      })
    },
    handleDlgRevert (row, index) { // 点击撤回证书
      let that = this
      that.revertIndex = index
      that.revertRow = row
      that.revertShow = true
    },
    cancleRevert () { // 取消
      this.$message({
        type: 'info',
        message: '取消撤回操作！',
        customClass: 'msg-position',
        showClose: true
      })
      this.revertShow = false
    },
    sureRevert () { // 确认
      this.handleRevert(this.revertIndex, this.revertRow.detail_id, this.revertRow.type)
      this.revertShow = false
    },
    handleRevert(index, detail_id, type) {
      let that = this
      that.loading = true
      this.$api.engineerHandleRevert({
        detail_id: detail_id,
        type: type
      }).then(res => {
        that.loading = false
        if (res.data.msg === true) {
          that.$message({
            type: 'success',
            message: '证书撤回成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.tableData[index].result = '7'
        } else {
          that.$message({
            type: 'error',
            message: res.data.error,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
      that.loading = false
    },
    cancleDelete () { // 取消删除
      this.sendShow = false
      this.$message({
        type: 'info',
        message: '取消此操作！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    sureDelete () { // 确认删除
      let that = this
      that.$api.sendOrder({
        lab_order_id: that.lab_order_id
      }).then(res => {
        if (res.data.msg === true) {
          that.status = '1'
          that.sendShow = false
          that.$message({
            type: 'success',
            message: '订单发样成功！！',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '订单发样失败！！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleEdit (row) { // 点击修改button
      this.dialogAdd = true
      this.device = {
        ...row,
        device_name: row.device_name,
        device_user: row.device_user,
        grade: row.grade,
        item_id: row.item_id,
        lab_order_id: row.lab_order_id,
        measure: row.measure,
        measure_type: Number(row.measure_type),
        service_type: Number(row.service_type),
        amount: Number(row.amount),
        next_date: moment(new Date(row.next_date)).format('YYYY-MM-DD'),
        memo: row.memo,
        price: row.price,
        service_lab_id: row.service_lab_id,
        equip_code: row.equip_code,
        vendor: row.vendor
      }
    },
    radioChange (val) { // 选择校验方式
      this.device.measure_type = val
    },
    serveChange(val) {
      this.device.service_type = val
    },
    saveDevice (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.updateOrderDevice({
            item_id: that.device.item_id,
            measure_type: that.device.measure_type,
            service_type: that.device.service_type,
            amount: that.device.amount,
            memo: that.device.memo,
            next_date: moment(new Date(that.device.next_date)).format('YYYY-MM-DD'),
            service_lab_id: that.device.service_lab_id,
            equip_code: that.device.equip_code,
            vendor: that.device.vendor
          }).then(res => {
            if (res.data.msg === true) {
              /* let index = that.tableData.findIndex(item => {
                return item.item_id ==that.device.item_id
              })
              let lab = that.options.filter(item => {
                return item.lab_id == that.device.service_lab_id
              })
              that.tableData.splice(index, 1, {...that.device, lab_name: lab[0].name}) */
              that.$message({
                type: 'success',
                message: '仪器修改成功！！',
                customClass: 'msg-position',
                showClose: true
              })
              that.initData()
              that.dialogAdd = false
            } else {
              that.$message({
                type: 'error',
                message: '仪器修改失败！！',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(e => {
            that.$message({
              type: 'error',
              message: `${e}`,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    handleDelete (row, index) { // 点击删除仪器
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.item_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },
    delete (index, item_id) { // 点击确认删除
      let that = this
      this.$api.deleteOrderDevice({
        item_id: item_id
      }).then(res => {
        if (res.data.msg === true) {
          that.tableData.splice(index, 1)
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    getLabs() {
      let that = this
      that.$api.getLabs({}).then(res => {
        that.options = res.data
      })
    },
    goSend(row) { // 规程修改
      this.device = {...row}
      let that = this
      var md5 = require('md5');
      let local_type = parseInt(that.device.type) + base.jl_online;
      let da = md5(`jl001${local_type}-${that.device.detail_id}`)
      let url = `${base.office}verify%2F${da}`;
      that.openHtml(url);
    },
    openHtml(URL) {
      let  temp_form = document.createElement("form");
      temp_form.action = URL;
      temp_form.target = "_blank";
      temp_form.method = "post";
      temp_form.style.display = "none";
      let opt = document.createElement("input");
      opt.name="access_token";
      opt.value="证书参数"
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      temp_form.submit();
    },
    download (row) {
      this.device = {...row}
      let that = this
      that.$api.download({
        type: that.device.type,
        detail_id: that.device.detail_id
      }).then(res => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let objectUrl = URL.createObjectURL(blob)
        window.open(objectUrl)
      })
    }
  },
  filters: {
    // CNAS状态
    cnas_filter(state) {
      if (state == 0) {
        return '不带CNAS'
      }
      if (state == 1) {
        return '带CNAS'
      }
    }
  },
  components: {
    DeleteBox
  },
  watch: {
    'device.service_type'(val) {
      if(val == 2|| val == 3) {
        this.getLabs()
      } else {
        this.device.service_lab_id = 0
        this.options = []
      }
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
.delete-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .delete-content
    background:#fff;
    z-index: 100001;
    width: 22rem;
    padding: 2rem 1rem;
    border-radius: 0.4rem;
    position: relative;
    .delete-title
      text-align:center;
      font-size:0.8rem;
      .el-icon-warning
        color:red;
        font-size:1rem;
    .delete-txt
      text-align: center;
      margin-top:1rem;
      font-size:0.9rem;
      font-weight:medium;
      color:#666;
    .btn-container
      margin-top:1.5rem;
      padding: 0rem 2rem;
      width:100%;
      color: #666;
      box-sizing:border-box;
      display: flex;
      .btn-list
        flex:1;
        color:#fff;
        border:0;
        &.cancle-btn
          background: #cfcfcf;
          color:#fff;
          span
            color:#fff;
        &.sure-btn
          background: #EF757A;
          span
            color:#fff;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#9a9a9a;
      font-size:1.2rem;
    .img-container
      width:20rem;
      height:20rem;
      padding: 1rem;
      .code-img
        display: block;
        width:18rem;
        height:18rem;
        border: 0.05rem solid #ececec;
</style>
